// Contact Information
export const CONTACT_INFO = {
  PRIMARY_PHONE: '+1 (647) 877-7766',
  PRIMARY_PHONE_RAW: '16478777766',
  OFFICE_PHONE: '+1 (416) 530-1080',
  OFFICE_PHONE_RAW: '14165301080',
  EMAIL: 'admin@teamshailesh.ca',
  ADDRESS: '836 Dundas St W, Toronto ON M6J1V5',
  CITY: 'Toronto',
  PROVINCE: 'Ontario',
  COUNTRY: 'Canada'
};

// Social Media Links
export const SOCIAL_LINKS = {
  FACEBOOK: 'https://www.facebook.com/profile.php?id=61573953766149',
  INSTAGRAM: 'https://www.instagram.com/sptherealtor/',
  YOUTUBE: 'https://www.youtube.com/@TeamShailesh',
  LINKEDIN: '#'
};

// WhatsApp
export const WHATSAPP_NUMBER = '16478777766';
